export enum LOCK_COLUMNS_ID {
  No = 'no',
  Type = 'type',
  Locked = 'locked',
  EarnedReward = 'earned_reward',
  AvailableReward = 'available_reward',
  Time = 'unlock_date',
  Action = 'action',
}

export const LOCK_COLUMNS = [
  { id: LOCK_COLUMNS_ID.No, title: 'No.' },
  { id: LOCK_COLUMNS_ID.Type, title: 'Type' },
  { id: LOCK_COLUMNS_ID.Locked, title: 'Total Lock' },
  { id: LOCK_COLUMNS_ID.EarnedReward, title: 'Earned Rewards' },
  { id: LOCK_COLUMNS_ID.AvailableReward, title: 'Available Rewards' },
  { id: LOCK_COLUMNS_ID.Time, title: 'Unlock Vault In' },
  { id: LOCK_COLUMNS_ID.Action, title: '' },
];
